import { z } from 'zod';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
import { EnumUtils } from '@colonist/utils';
import { PlayerColor } from '../PlayerState.ts';
const mechanicCityWallPlayerStateSchema = z.object({
    bankCityWallAmount: z.number().int().nonnegative()
}).strict();
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const mechanicCityWallStateSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicCityWallPlayerStateSchema);
export function validateMechanicCityWallState(data) {
    return validateState(mechanicCityWallStateSchema, data);
}
const mechanicCityWallPlayerStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicCityWallPlayerStateSchema);
export const mechanicCityWallStatePartialSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicCityWallPlayerStatePartialSchema, {
    requireAtLeastOneEntry: true
});
